module.exports = __webpack_public_path__ + "static/formations-464fb4a42210abf97ff37a38231039a0.jpg";